import type { UserResponse } from "stream-chat";
import api from "@/shared/services/apiClient";
import { STORAGE_KEYS } from "@/config/constants";
import { storage } from "@/shared/utils/storage";

export const streamService = {
  getContacts: async (search = ""): Promise<UserResponse[]> => {
    const response = await api.get("/stream/contacts", { params: { search } });
    return response.data;
  },
  createChannel: async (userIds: string[], name?: string): Promise<string> => {
    const response = await api.post("/stream/channel/create", { userIds, name });
    return response.data.channelId;
  },
  getToken: async () => {
    const userId = storage.get(STORAGE_KEYS.USER_ID);
    const response = await api.get(`/stream/token/${userId}`);
    return response.data.token;
  },

  removeChannelMember: async (channelId: string, userId: string) => {
    await api.post("/stream/channel/remove-member", { channelId, userId });
  },
  addChannelMember: async (channelId: string, userId: string) => {
    await api.post("/stream/channel/add-member", { channelId, userId });
  },
};
